import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {newGuid} from '../question-helper';

@Component({
    selector: 'app-question-grouped-multiselect',
    templateUrl: './question-grouped-multiselect.component.html',
    styleUrls: ['./question-grouped-multiselect.component.scss'],
    standalone: false
})
export class QuestionGroupedMultiSelectComponent implements OnInit {

  @Input() question: Question;
  @Input() readonly = false;
  @Input() items: any[] = [];
  @Output() questionAnswer = new EventEmitter<any>();

  uniqueControlName = `grouped-multi-select-${newGuid()}`;
  constructor() { }

  ngOnInit(): void {
  }

  getHeadings(){
    let groupsDict : {} = this.items.reduce((r:any,a:any) => {
      r[a.heading] = [...r[a.heading] || [], a];
      return r;
    }, {});

    let groupArray = Object.entries(groupsDict);
    let headings = [];
    groupArray?.forEach((item: any) => {
      headings.push(item[0]);
    });
    return headings;
  }

  getItems(heading: any){
    return this.items.filter((item: any) => item.heading == heading);
  }

  checkMultiSelect(): void {
    const selectedOptions = [];
    const checkboxes = document.getElementsByName(`${this.uniqueControlName}`);

    // @ts-ignore
    for (const c of checkboxes) {
      const el = c as HTMLInputElement;
      if (el.checked) {
        selectedOptions.push(el.value);
      }
    }
    if (selectedOptions?.length) {
      this.submitAnswer(selectedOptions.join('|'));
    }
  }

  submitAnswer(value: any): void {
    if (this.question) {
      this.question.answer = value;
      this.questionAnswer.emit(this.question);
    } else {
      this.questionAnswer.emit(value);
    }
  }

}
